import { SelectBilhetadoraOperadoraService } from './select-bilhetadora-operadora.service';
import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BilhetadoraService } from 'src/app/api-service/bilhetadora.service';
import { OperadoraService } from 'src/app/api-service/operadora.service';
import { Bilhetadora } from 'src/app/models/bilhetadora';
import { Operadora } from 'src/app/models/operadora';
import { SessionService } from '../../../core/services/session/session.service';

@Component({
  selector: 'app-select-bilhetadora-operadora',
  templateUrl: './select-bilhetadora-operadora.component.html',
  styleUrls: ['./select-bilhetadora-operadora.component.scss'],
})
export class SelectBilhetadoraOperadoraComponent implements OnInit {
  public bilhetadoraId: string;
  public operadoraId: string;
  public bilhetadoras: Bilhetadora[] = [];
  public operadoras: Operadora[] = [];
  public desabilitarBilhetadoraSelect = false;
  public desabilitarOperadoraSelect = false;

  @Input() styleClass: string;
  @Input() modeloSeletor: string;
  @Input() bilhetadoraIdSelecionada?: string;
  @Input() operadoraIdSelecionada?: string;
  @Output() bilhetadoraSelecionada: EventEmitter<number> = new EventEmitter<number>();
  @Output() operadoraSelecionada: EventEmitter<number> = new EventEmitter<number>();
  @Output() operadoraModel: EventEmitter<Operadora> = new EventEmitter<Operadora>();
  @Output() bilhetadoraModel: EventEmitter<Bilhetadora> = new EventEmitter<Bilhetadora>();

  constructor(
    private operadoraService: OperadoraService,
    private bilhetadoraService: BilhetadoraService,
    private selectBilhetadoraOperadoraService: SelectBilhetadoraOperadoraService,
    public session: SessionService
  ) {
    this.selectBilhetadoraOperadoraService.solicitacaoReset.subscribe(() => this.resetForm());
  }

  ngOnInit() {
    this.getBilhetadoras().catch((error) => console.log(error));

    if (this.bilhetadoraIdSelecionada) this.bilhetadoraId = this.bilhetadoraIdSelecionada;

    if (this.operadoraIdSelecionada) this.operadoraId = this.operadoraIdSelecionada;

    if (this.session.hasBilhetadoraId()) {
      this.desabilitarBilhetadoraSelect = true;
      this.bilhetadoraId = this.session.getBilhetadoraId().toString();
      this.changedBilhetadora(+this.bilhetadoraId);
      this.getOperadoras();
    } else {
      this.desabilitarBilhetadoraSelect = true;
      this.desabilitarOperadoraSelect = true;
      this.getOperadoras();
    }
  }

  public async getBilhetadoras() {
    const params: HttpParams = new HttpParams().append('PageIndex', '1').append('listAll', 'true');
    await this.bilhetadoraService.getBilhetadoras(params).then((bils: any) => {
      this.bilhetadoras = bils.data.itens
        .map((b) => new Bilhetadora(b))
        .sort((a, b) => a.nomeFantasia.localeCompare(b.nomeFantasia));
    });
  }

  public async getOperadoras() {
    if (this.bilhetadoraId) {
      this.operadoraId = undefined;
      const params: HttpParams = new HttpParams().append('BilhetadoraId', this.bilhetadoraId.toString()).append('PageIndex', '1').append('listAll', 'true');

      await this.operadoraService.getOperadoras(params).then((ops) => {
        this.operadoras = ops.data.itens
          .map((o) => new Operadora(o))
          .sort((a, b) => a.nomeFantasia.localeCompare(b.nomeFantasia));
      });
    } else {
      const params: HttpParams = new HttpParams()
        .append('id', this.session.getOperadoraId().toString())
        .append('PageIndex', '1')
        .append('listAll', 'true');
      await this.operadoraService.getOperadoras(params).then((ops) => {
        this.operadoras = ops.data.itens
          .map((o) => new Operadora(o))
          .sort((a, b) => a.nomeFantasia.localeCompare(b.nomeFantasia));
        this.bilhetadoraId = this.operadoras[0].bilhetadoraId.toString()
        this.operadoraId = this.operadoras[0].id.toString()
        this.operadoraSelecionada.emit(+this.operadoraId);
      });
    }
    this.changedBilhetadora(+this.bilhetadoraId);
  }

  public  changedBilhetadora(bilhetadoraId: number) {
    if (bilhetadoraId) {
      this.bilhetadoraSelecionada.emit(bilhetadoraId);
      const b = this.bilhetadoras.find((x) => x.id === +bilhetadoraId);
      this.bilhetadoraModel.emit(b);
    } else {
      this.bilhetadoraSelecionada.emit(0);
    }
  }

  public changedOperadora(operadoraId: number) {
    if (operadoraId) {
      this.operadoraSelecionada.emit(operadoraId);
      const o = this.operadoras.find((x) => x.id === +operadoraId);
      this.operadoraModel.emit(o);
    } else {
      this.operadoraSelecionada.emit(0);
    }
  }

  public resetForm() {
    this.bilhetadoras = [];
    this.operadoras = [];
    this.bilhetadoraId = undefined;
    this.operadoraId = undefined;
    this.changedOperadora(undefined);
    this.changedBilhetadora(undefined);
    this.getBilhetadoras().catch((error) => console.log(error));
  }
}
